/**
 * Feature flags configuration
 * 
 * This is controlled by developers/deployment process, not exposed to users
 * To enable a feature, change the value to true in this file before deployment
 */
export interface FeatureFlags {
    useRemoteLevels: boolean;
    useHypercardTheme: boolean;
  }
  
  /**
   * DEVELOPER CONFIGURATION:
   * Set this to true when the "Levels of the Day" API endpoint is ready for production
   */
  export const featureFlags: FeatureFlags = {
    useRemoteLevels: true, // Set to true to use remote levels from API
    useHypercardTheme: true, // Set to true to use HyperCard-style retro theme
  };
  
  /**
   * In a real production environment, you might load this configuration from:
   * - Environment variables
   * - Backend API during app initialization
   * - Feature flag service like LaunchDarkly, Split.io, etc.
   * 
   * Example with environment variables (using Create React App):
   * 
   * export const featureFlags: FeatureFlags = {
   *   useRemoteLevels: process.env.REACT_APP_USE_REMOTE_LEVELS === 'true',
   * };
   */